// The FILE.* codes both uploads (contact tracing and screening) answer with when the file is rejected.
export type ImportFileCode =
  | 'FILE.REQUIRED'
  | 'FILE.EMPTY'
  | 'FILE.INVALID_EXTENSION'
  | 'FILE.INVALID_XLSX'
  | 'FILE.WORKSHEET_MISSING'
  | 'FILE.HEADER_ROW_MISSING'
  | 'FILE.HEADER_BLANK'
  | 'FILE.HEADER_INVALID'
  | 'FILE.HEADER_ORDER_INVALID'
  | 'FILE.HEADER_EXTRA'
  | 'FILE.UNEXPECTED_COLUMN_DATA'
  | 'FILE.NO_PERSON_DATA'
  | 'FILE.PERSON_REQUIRED_FIELD_MISSING';

// The codes POST /api/import-file/contact-tracing answers with instead of a message.
export type ContactTracingImportCode =
  | 'CONTACT_TRACING_IMPORT.SUCCESS'
  | 'CASE_ID.REQUIRED'
  | 'CASE_ID.INVALID'
  | 'CASE_ID.NOT_FOUND'
  | 'CASE_ID.NOT_INDEX_CASE'
  | ImportFileCode
  | 'CONTACT_TRACING_IMPORT.INTERNAL_ERROR';

export function getContactTracingImportMessage(code: string | undefined): string {
  switch (code) {
    case 'CONTACT_TRACING_IMPORT.SUCCESS':
      return 'Die Datei wurde erfolgreich hochgeladen';
    case 'CASE_ID.REQUIRED':
      return 'Indexpatient muss angegeben werden';
    case 'CASE_ID.INVALID':
      return 'Die ID des Indexpatienten ist ungültig';
    case 'CASE_ID.NOT_FOUND':
      return 'Der Indexpatient wurde nicht gefunden';
    case 'CASE_ID.NOT_INDEX_CASE':
      return 'Der ausgewählte Patient ist kein Indexfall';
    case 'FILE.NO_PERSON_DATA':
      return 'Die Datei enthält keine Kontaktpersonen';
    case 'CONTACT_TRACING_IMPORT.INTERNAL_ERROR':
      return 'Die Datei konnte nicht verarbeitet werden. Bitte später erneut versuchen.';
    default:
      return getImportFileCodeMessage(code);
  }
}

// The messages for the FILE.* codes, also the fallback for unknown codes.
export function getImportFileCodeMessage(code: string | undefined): string {
  switch (code) {
    case 'FILE.REQUIRED':
      return 'Datei muss ausgewählt werden';
    case 'FILE.EMPTY':
      return 'Die Datei ist leer';
    case 'FILE.INVALID_EXTENSION':
      return 'Die Datei muss die Endung .xlsx haben';
    case 'FILE.INVALID_XLSX':
      return 'Die Datei ist keine gültige Excel-Datei (.xlsx)';
    case 'FILE.WORKSHEET_MISSING':
      return 'Die Datei enthält kein Tabellenblatt';
    case 'FILE.HEADER_ROW_MISSING':
      return 'Die erste Zeile des ersten Tabellenblatts muss die Spaltenüberschriften enthalten';
    case 'FILE.HEADER_BLANK':
      return 'Eine Spaltenüberschrift fehlt. Bitte die Beispiel-Datei verwenden.';
    case 'FILE.HEADER_INVALID':
      return 'Die Datei enthält eine ungültige Spaltenüberschrift. Bitte die Beispiel-Datei verwenden.';
    case 'FILE.HEADER_ORDER_INVALID':
      return 'Die Spalten sind nicht in der richtigen Reihenfolge. Bitte die Beispiel-Datei verwenden.';
    case 'FILE.HEADER_EXTRA':
      return 'Die Datei enthält zusätzliche Spalten. Bitte die Beispiel-Datei verwenden.';
    case 'FILE.UNEXPECTED_COLUMN_DATA':
      return 'Die Datei enthält Daten in Spalten ohne Spaltenüberschrift. Bitte nur die Spalten der Beispiel-Datei verwenden.';
    case 'FILE.NO_PERSON_DATA':
      return 'Die Datei enthält keine Personen';
    case 'FILE.PERSON_REQUIRED_FIELD_MISSING':
      return 'In mindestens einer Zeile fehlt Vorname, Nachname oder Geburtsdatum';
    default:
      return 'Beim Hochladen der Datei ist ein Fehler aufgetreten';
  }
}
